import client from 'client';

import type { UserSearchResponse, RequestWithPagination } from './types';

export type UserMatchesResponse = UserSearchResponse & {
    fromCache: boolean;
    candidatesAmount: number;
};

type FetchUserMatches = (
    eventId: number,
    payload: RequestWithPagination
) => Promise<UserMatchesResponse>;

export const fetchUserMatches: FetchUserMatches = async (eventId, payload) => {
    const url = `/api/v2/people/events/${eventId}/userMatches`;
    const response = await client().post<UserMatchesResponse>(url, payload);

    return response.data;
};
